const TestUserAgent = require('./TestUserAgent');
const autoplayPermissionMap = {
    denied: {
        regExp:
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
        browsersRegExp: /Safari|Chrome/i
    }
};

module.exports.permission = TestUserAgent(autoplayPermissionMap);
module.exports.isAllowed = module.exports.permission !== 'denied';


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/utils/MediaAutoplaySupport.js